module.exports = __webpack_public_path__ + "img/accessory_hat_03.ccf5f32c.svg";